<div class="search-bar-container" [attr.data-testid]="'vi-search-bar-container-' + (placeholder || 'default')">
  <div class="indication-icon"
    [ngClass]="{'accessible': accessibilityMode, 'clear-btn': isSearching}"
    [attr.tabindex]="isSearching ? 0 : -1"
    [attr.role]="isSearching ? 'button' : 'none'"
    (viUiAccessibleClick)="handleIconClicked()"
    [attr.data-testid]="'vi-search-bar-icon-' + (placeholder || 'default')">
    <i [ngClass]="{'i-vi-search': !isSearching, 'i-vi-close-small': isSearching }">
    </i>
  </div>
  <vi-ui-composable-input #input
    [messages]="messages"
    [placeholder]="placeholder"
    (messagesChange)="handleMessagesChange($event)"
    (componentDeleted)="handleComponentDeleted($event)"
    (currentFocused)="handleCurrentFocused($event)"
    (keyup.enter)="handleSearchClicked($event)"
    [attr.data-testid]="'vi-search-bar-input-' + (placeholder || 'default')">
  </vi-ui-composable-input>
</div>
@if(isSearching) {
<div class="search-btn"
  [ngClass]="{'accessible': accessibilityMode}"
  role="button"
  tabindex="0"
  (viUiAccessibleClick)="handleSearchClicked()"
  [attr.data-testid]="'vi-search-bar-button-' + (placeholder || 'default')">
  <i class="i-vi-search" [attr.data-testid]="'vi-search-bar-button-icon-' + (placeholder || 'default')">
  </i>
</div>
}
